import { combineReducers } from '@reduxjs/toolkit';
import * as reducers from '~/features';

const rootReducer = combineReducers({
  appCommon: reducers.appCommon,
  axiosError: reducers.axiosError,
  apiRequest: reducers.apiRequest,
  areas: reducers.areas,
  user: reducers.user,
  users: reducers.users,
  adminAndRoles: reducers.adminAndRoles,
  roles: reducers.roles,
  admin: reducers.admin,
  survey: reducers.survey,
  surveys: reducers.surveys,
  invoiceRecipient: reducers.invoiceRecipient,
  qualifications: reducers.qualifications,
  quotas: reducers.quotas,
  surveyPayment: reducers.surveyPayment,
  surveyRejectHistory: reducers.surveyRejectHistory,
  passwordReset: reducers.passwordReset,
  validation: reducers.validation,
  judgement: reducers.judgement,
  originalForm: reducers.originalForm,
});

export default rootReducer;
